import axiosRequest from "@/api/axios-optimize"

// 获取列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry`, { params: data, ...config})
}

// 新增
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/entry`, data, config)
}

// 获取详情
export function getDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/${data.id}`, { params: {}, ...config})
}

// 更新
export function updateItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.put(`/xiaobuAdmin/inventory/entry/${data.entryId}`, data, config)
}

// 作废入库单
export function discardEntry(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/entry/discardEntry`, data, config)
}

// 删除
export function deleteItem(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/inventory/entry/${data.id}`, { ...config}) // 省略data入参 或 params入参
}

// 获取启用的仓库id列表
export function getAllWareHouseIds(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/wareHouse/findAllWareHouseIds`, { params: data, ...config})
}

// 根据spuIds查找对应已存在的spuId
export function getExistingSpuIds(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/spu/getExistingSpuIds`, data, config)
}

// 确认入库
export function confirmEntry(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/entry/confirmEntry`, data, config)
}

// 获取入库列表
export function getEntryDetail(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/getEntryDetail`, { params: data, ...config})
}

// 获取出库商品列表
export function getOutList(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/getOutList`, { params: data, ...config})
}

// 根据出库单数据超找对应的列表
export function findAllByOutSpuIds(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/findAllByOutSpuIds`, { params: data, ...config})
}

// 批量删除入库单
export function batchDeleteItems(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/inventory/entry/batchDelete`, { data, ...config})
}

// 校验出库单号填写是否正确
export function checkOutNo(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/entry/checkOutNo`, data, config)
}

// 通过出库单号 获取客户数据
export function getCustomerDataByOutNo(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/entry/getCustomerDataByOutNo`, { params: data, ...config})
}